import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ButtonDropdown from '../dropdown/ButtonDropdown';
import { isEmpty } from 'lodash';
var TreeOptions = function TreeOptions(props) {
  var treeOptions = props.treeOptions,
    className = props.className;
  if (isEmpty(treeOptions)) {
    return null;
  }
  var dropdownClasses = classNames('width-250', 'padding-10', className);
  var customDropdown = /*#__PURE__*/React.createElement("div", {
    className: dropdownClasses
  }, treeOptions);
  return /*#__PURE__*/React.createElement(ButtonDropdown, {
    title: /*#__PURE__*/React.createElement("span", {
      className: "rioglyph rioglyph-option-vertical",
      "aria-hidden": "true"
    }),
    bsStyle: 'muted',
    customDropdown: customDropdown,
    className: 'TreeHeaderOptions',
    pullRight: true,
    iconOnly: true
  });
};
TreeOptions.displayName = 'TreeOptions';
TreeOptions.defaultProps = {
  treeOptions: []
};
TreeOptions.propTypes = {
  treeOptions: PropTypes.arrayOf(PropTypes.node),
  className: PropTypes.string
};
export default TreeOptions;